import { uiStore } from "@/store/store";

function getElementRect(element: HTMLElement | null) {
  // Handle .oxy-component, which uses `display: contents`. We return its first visible child.
  if (
    element?.parentElement?.classList?.contains("oxy-component") &&
    element?.children?.length
  ) {
    return element.children[0]?.getBoundingClientRect();
  }

  return element?.parentElement?.getBoundingClientRect();
}

export function calculateBackdropCutoutSize(element: HTMLElement) {
  const rect = getElementRect(element);

  if (!rect) return;

  uiStore.setInlineEditingContext({
    ...uiStore.inlineEditingContext,
    rect: {
      top: rect.top,
      left: rect.left,
      bottom: rect.bottom,
      right: rect.right,
      width: rect.width,
      height: rect.height,
      y: rect.y,
      x: rect.x
    }
  });
}

export function startBackdropListeners(element: HTMLElement) {
  const calcFn = () => calculateBackdropCutoutSize(element);
  const doc = window.Breakdance?.canvas?.document;

  doc.addEventListener("scroll", calcFn, { passive: true });

  const ResizeObserver = doc.defaultView?.ResizeObserver;
  const resizeObserver = ResizeObserver ? new ResizeObserver(calcFn) : null;

  resizeObserver?.observe(element.parentElement ?? element);

  calcFn();

  return () => {
    doc.removeEventListener("scroll", calcFn);
    resizeObserver?.disconnect();
  };
}
